<script lang="jsx">
import BuyNow from './buy-now.vue';
import EditDelta from "./edit-delta.vue";
import EditSimple from "./edit-simple.vue";
import Edit from "./edit.vue";
import Add from './add.vue';
import Switch from './switch.vue';
import AddTrial from './add-trial.vue';
import Trial2paid from './trial2paid.vue';
import planPropsMixin from '@/plans/mx/plan-props';
import planCommonMixin from '@/plans/WEBINAR/mixin';
import { isAutoAddable } from '@/plans/ZOOM_MEETING/common/utils';

export default {
  mixins: [planPropsMixin, planCommonMixin],
  render() {
    const context = {...this.$props, ...this.$attrs};
    if (this.$context.is.add2cart) return <Add {...context} />;
    if (this.$context.is.add2trial) return <AddTrial {...context} />;
    if (this.$context.is.trial2paid) return <Trial2paid {...context} />;
    if (this.$context.is.edit) {
      if (this.$context.is.simplify) {
        return <EditSimple />;
      }
      if (this.$context.is.addQty && isAutoAddable()) {
        return <EditDelta {...context} />;
      } else {
        return <Edit {...context} />;
      }
    }
    if (this.$context.is.switch) return <Switch {...context} />
    if (this.$context.is.buyNow || this.$context.is.basic2pro) return <BuyNow {...context} />;
    return null;
  },
};
</script>
